import styled from "styled-components";

import { colorsPalettes, setFontVariant, rgba } from "@similarweb/styles";
import { Button, FlexRow } from "@similarweb/ui-components";

import { BANNER_HEIGHT, VERTICAL_PADDING } from "../constants";

export const BannerContainer = styled(FlexRow)`
    height: ${BANNER_HEIGHT - 2 * VERTICAL_PADDING}px;
    background-color: ${colorsPalettes.blue[400]};
    padding: ${VERTICAL_PADDING}px 24px;
    justify-content: space-between;
    align-items: center;

    &.middle-banner {
        border-radius: 4px;
        margin: 16px 0;
        padding: 8px 16px;
    }
`;

export const TextWithIconWrapper = styled(FlexRow)`
    align-items: center;
`;

export const TextWrapper = styled.span`
    ${setFontVariant("input2", colorsPalettes.carbon[0])};
    padding-left: 12px;
`;

export const ActionsWrapper = styled(FlexRow)`
    gap: 24px;
    justify-content: space-between;
    align-items: center;
`;

export const CTAButton = styled(Button)`
    color: ${colorsPalettes.blue[500]};
`;

export const CloseIconWrapper = styled(FlexRow)`
    width: 40px;
    height: 40px;
    border-radius: 100px;
    justify-content: center;
    align-items: center;

    &:hover {
        cursor: pointer;
        background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};
    }
`;

export const Icon = styled.img`
    width: 24px;
    height: 24px;
`;
